/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=5d49c8a0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "../../assets/css/collection.css?vue&type=style&index=0&id=5d49c8a0&scoped=true&lang=css&external"
import "./index.vue?vue&type=style&index=1&id=5d49c8a0&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d49c8a0"]])

export default __exports__